<template>
<div class="contrast">
  <div class="contrast-title" v-if="cItem.hide_title == 0">
    <img :src="static_img_url + 'pic/module_tct_icon.png'" />{{cItem.title}}
  </div>
  <div class="contrast-summary" v-html="cItem.summary"></div>
  <div class="contrast-nav">
    <CheckboxGroup v-model="annotation_tag_list">
      <Checkbox :label="item" v-for="item, index in cItem.content.x" :key="index">
        <span>{{item | dealName(meta.annotation_tag)}}</span>
      </Checkbox>
    </CheckboxGroup>
  </div>
  <div style="position: relative; overflow: hidden; margin-top: 10px;">
    <div class="contrast-left-nav">
      <div class="left-nav-top" v-if="cItem.time_show_type == 0">地区/年</div>
      <div class="left-nav-top" v-if="cItem.time_show_type == 1">地区/季度</div>
      <div class="left-nav-top" v-if="cItem.time_show_type == 2">地区/月</div>
      <div class="left-nav" >
        <div v-for="item in cItem.content.y" :key="item" :style="{'min-height': cItem.content.x.length * 9 - 2 + 'px'}">{{item | dealName(meta.address)}}</div>
      </div>
    </div>
    <div class="contrast-bg">
      <div class="contrast-content">
        <div class="contrast-head">
          <div class="head-1" v-if="cItem.time_show_type == 0">地区/年</div>
          <div class="head-1" v-if="cItem.time_show_type == 1">地区/季度</div>
          <div class="head-1" v-if="cItem.time_show_type == 2">地区/月</div>
          <div class="head-2">
            <div
              class="head-item"
              v-for="year_item,year_index in years_axis"
              :key="year_index"
            >
              <span>{{year_item | tct_time_list(cItem.time_show_type)}}</span>
            </div>
          </div>
        </div>
        <div class="contrast-list">
          <div class="contrast-li" v-for="item in cItem.content.y" :key="item">
            <div class="label-tag">{{item | dealName(meta.address)}}</div>
            <div class="label-data">
              <div
                class="year-item"
                v-for="year_item,year_index in years_axis"
                :key="year_index"
              >
                <div>
                  <div
                    class="data-item"
                    v-for="item2,index2 in cItem.content.x"
                    :key="index2"
                  >
                    <Tooltip
                      :placement="tooltip_placement(year_index, years_axis.length)"
                      v-for="item3,index3 in cItem.content.res"
                      :key="index3"
                      v-if="item3.tag_id == item2 && item3.address_id == item && time_bollen(item3, year_item) && annotation_tag_list.findIndex((a) => a == item3.tag_id) > -1"
                    >
                      <span
                        :style="{'width': '30px', 'background-color': colors[index2] || 'rgba(250, 122, 80, 1)'}"
                        @click="handleClickItem(item3)"
                      ></span>
                      <div slot="content" @click="handleClickItem(item3)">
                        <p class="p1">{{item | dealName(meta.address)}}（共{{item3.ca_num}}起）</p>
                        <p class="p2">
                          <i :style="{'background-color': colors[index2] || 'rgba(250, 122, 80, 1)'}"></i>{{item2 | dealName(meta.annotation_tag)}}
                        </p>
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <p>数据来源：{{cItem.src_name | empty('动脉橙产业智库')}}</p>
  <div class="spa">
    <Poptip trigger="hover" placement="bottom-end" padding="0" width="248" @on-popper-show="handleShare(paramsUid)" @on-popper-hide="handleShareHide">
      <i class="iconfont">&#xe641;</i>
      <div slot="content" class="share_cnt clear">
        <div class="share_img"></div>
        <p>打开微信“扫一扫”<br />点击右上角分享按钮</p>
      </div>
    </Poptip>
  </div>
  <Modal
    v-model="detail_modal"
    class="detail-modal"
    width="500"
    @on-visible-change="list_show_index = []"
    >
    <div slot="header">{{modal_address | dealName(meta.address)}}(共{{policy_list.length}}起)</div>
    <div class="list">
      <div v-for="item,index in policy_list" :key="index">
        <i class="iconfont">&#xe62b;</i>
        <div class="li-top">
          <span @click="goPolicyDetail(item)">{{item.name}}</span>
        </div>
        <div class="li-cnt" v-if="item.content">
          {{item.content.length > 100 && !list_show(index) ?  item.content.substr(0, 100).concat('...') : item.content }}
          <span v-if="item.content.length > 100" @click="haddleClickShow(index)">{{list_show(index) ? '收起' : '展开'}}</span>
        </div>
        <div class="li-bto">
          <span>{{item.publish_time | time_moment}}</span>
          <span>{{item.publish_org}}</span>
        </div>
      </div>
    </div>
    <div slot="footer">
      <Button @click="detail_modal = !detail_modal">知道了</Button>
    </div>
  </Modal>
</div>
</template>
<script>
import { policyAnnotation } from '../../../service'
export default {
  props: ['cItem', 'paramsUid', 'meta'],
  data() {
    return {
      colors: ['#E96350','#FFCB6A','#A6D911','#36CFC9','#40A9FF','#F88C52','#FFCCBC','#53C419','#1EA69B','#2F54EB'],
      annotation_tag_list: [],
      policy_list: [],
      detail_modal: false,
      modal_address: '',
      list_show_index: []
    }
  },
  computed: {
    list_show() {
      return function(i) {
        let index = this.list_show_index.findIndex((a) => a == i)
        if (index > -1) {
          return true
        } else {
          return false
        }
      }
    },
    static_img_url() {
      return this.$store.state.static_img_url
    },
    years_axis() {
      let arr = [],
          start_year = this.cItem.start_time ? moment(this.cItem.start_time).year() : 2010,
          end_year = this.cItem.end_time ? moment(this.cItem.end_time).year() : moment().year(),
          start_quarter = this.cItem.start_time ? moment(this.cItem.start_time).quarter() : 1,
          end_quarter = this.cItem.end_time ? moment(this.cItem.end_time).quarter() : moment().quarter(),
          start_month = this.cItem.start_time ? moment(this.cItem.start_time).month() + 1 : 1,
          end_month = this.cItem.end_time ? moment(this.cItem.end_time).month() + 1 : moment().month() + 1
      for (var i = start_year; i <= end_year; i++) {
        if (this.cItem.time_show_type == 0) {
          arr.push(i)
        } else if (this.cItem.time_show_type == 1){
          if (i == start_year && i != end_year) {
            for (var j = start_quarter; j <= 4; j++) {
              arr.push(i+'Q'+j)
            }
          } else if (i == end_year && i != start_year) {
            for (var j = 1; j <= end_quarter; j++) {
              arr.push(i+'Q'+j)
            }
          } else if (i == start_year && i == end_year) {
            for (var j = start_quarter; j <= end_quarter; j++) {
              arr.push(i+'Q'+j)
            }
          } else {
            for (var j = 1; j <= 4; j++) {
              arr.push(i+'Q'+j)
            }
          }
        } else if (this.cItem.time_show_type == 2){
          if (i == start_year && i != end_year) {
            for (var j = start_month; j <= 12; j++) {
              arr.push(i+'.'+j)
            }
          } else if (i == end_year && i != start_year) {
            for (var j = 1; j <= end_month; j++) {
              arr.push(i+'.'+j)
            }
          } else if (i == start_year && i == end_year) {
            for (var j = start_month; j <= end_month; j++) {
              arr.push(i+'.'+j)
            }
          } else {
            for (var j = 1; j <= 12; j++) {
              arr.push(i+'.'+j)
            }
          }
        }
      }
      return arr
    },
    time_bollen() {
      return function(item, t) {
        if (this.cItem.time_show_type == 0) {
          return item.year == t
        } else if (this.cItem.time_show_type == 1) {
          return item.year == t.split('Q')[0] && item.quarter == t.split('Q')[1]
        } else if (this.cItem.time_show_type == 2) {
          return item.year == t.split('.')[0] && item.month == t.split('.')[1]
        }
      }
    },
    tooltip_placement() {
      return function(idx, len) {
        let p = 'top'
        if (idx == len - 1) {
          p = 'top-end'
        }
        if (idx == 0) {
          p = 'top-start'
        }
        return p
      }
    }
  },
  methods: {
    async handleClickItem(item) {
      this.modal_address = item.address_id
      let res = await policyAnnotation({
        ids: item.ca_ids
      }, (error) => this.$Message.error('请求错误！'))
      if(res.status == 'success') {
        this.$set(this.$data, 'policy_list', res.res)
        this.detail_modal = true
      } else {
        this.$Message.error(res.message)
      }
    },
    goPolicyDetail(item) {
      const {
        href
      } = this.$router.resolve({
        name: "PolicyDetail",
        params: {
          uid: item.uid
        }
      })
      window.open(href, '_blank')
    },
    haddleClickShow(val) {
      let index = this.list_show_index.findIndex((a) => a == val)
      if (index > -1) {
        this.list_show_index.splice(index, 1)
      } else {
        this.list_show_index.push(val)
      }
    },
    handleShare(theme_uid) {
      let share_link = window.location.protocol + '//' + window.location.host + '/mindex/shareScatter?tct_id='+this.cItem.id+'&theme_uid=' + theme_uid
      console.log(share_link)
      jQuery($('.share_img')).qrcode({
        width: 80,
        height: 80,
        correctLevel: 0,
        text: share_link
      })
    },
    handleShareHide() {
      $('.share_img').html('')
    }
  },
  created() {
    this.annotation_tag_list = this.cItem.content.x
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/constrast.stylus'
.contrast .contrast-left-nav .left-nav-top
  height: 44px
  padding: 0 0 0 20px
.contrast .contrast-left-nav .left-nav > div
  padding: 16px 20px
  width: 60px
  box-sizing: content-box
  display: flex
  align-items: center;
.contrast
  &-nav >>> .ivu-checkbox-wrapper
    &:nth-of-type(1)
      .ivu-checkbox-checked
        .ivu-checkbox-inner
          border-color: #E96350
          background-color: #E96350
    &:nth-of-type(2)
      .ivu-checkbox-checked
        .ivu-checkbox-inner
          border-color: #FFCB6A
          background-color: #FFCB6A
    &:nth-of-type(3)
      .ivu-checkbox-checked
        .ivu-checkbox-inner
          border-color: #A6D911
          background-color: #A6D911
    &:nth-of-type(4)
      .ivu-checkbox-checked
        .ivu-checkbox-inner
          border-color: #36CFC9
          background-color: #36CFC9
    &:nth-of-type(5)
      .ivu-checkbox-checked
        .ivu-checkbox-inner
          border-color: #40A9FF
          background-color: #40A9FF
    &:nth-of-type(6)
      .ivu-checkbox-checked
        .ivu-checkbox-inner
          border-color: #F88C52
          background-color: #F88C52
    &:nth-of-type(7)
      .ivu-checkbox-checked
        .ivu-checkbox-inner
          border-color: #FFCCBC
          background-color: #FFCCBC
    &:nth-of-type(8)
      .ivu-checkbox-checked
        .ivu-checkbox-inner
          border-color: #53C419
          background-color: #53C419
    &:nth-of-type(9)
      .ivu-checkbox-checked
        .ivu-checkbox-inner
          border-color: #1EA69B
          background-color: #1EA69B
    &:nth-of-type(10)
      .ivu-checkbox-checked
        .ivu-checkbox-inner
          border-color: #2F54EB
          background-color: #2F54EB
.detail-modal
  >>> .ivu-modal-wrap .ivu-modal .ivu-modal-content .ivu-modal-body .list
    max-height: 343px
    > div
      .li-bto span
        color: #999
</style>
